export default {
  state: {
    filter: {
      account_name: undefined,
      cmp_type: undefined,
      owner_account: undefined,
      http: undefined,
      status: undefined,
    },
    items: [],
  },
  getters: {},
  mutations: {
    APPLY_FILTER: (state: any, payload: any) => (state.filter = payload),
    SET_CMPS: (state: any, payload: any[]) => (state.items = payload),
  },
  actions: {
    applyFilter: (context: any, payload: any) => context.commit("APPLY_FILTER", payload),
    setCmps: (context: any, payload: any[]) => context.commit("SET_CMPS", payload),
  },
};
